import React from 'react'

const ReeferSettingsContext = React.createContext()

export default ReeferSettingsContext
